export const SET_FORM_DATA = 'SET_FORM_DATA'
export const LOGIN_USER = 'LOGIN_USER'
export const REMOVE_USER = 'REMOVE_USER'
export const SET_TOKEN = 'SET_TOKEN'
export const REMOVE_TOKEN = 'REMOVE_TOKEN'
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const RESET_LANGUAGE = 'RESET_LANGUAGE'
export const EMPLOYEE_LOG = 'EMPLOYEE_LOG'
export const RESET_EMPLOYEE_LOG = 'RESET_EMPLOYEE_LOG'
export const EMPLOYEE_LOG_SUMMARY = "EMPLOYEE_LOG_SUMMARY";
export const RESET_EMPLOYEE_LOG_SUMMARY = "RESET_EMPLOYEE_LOG_SUMMARY";
export const EMPLOYEE_NAME = "EMPLOYEE_NAME";
export const RESET_EMPLOYEE_NAME = "RESET_EMPLOYEE_NAME";
export const SET_ESTIMATION_DATA = "SET_ESTIMATION_DATA";
export const SET_ESTIMATION_LOADING = "SET_ESTIMATION_LOADING"
export const ALL_USERS = "ALL_USERS"
export const SET_USER_PAGE = "SET_USER_PAGE"
export const SET_USER_PAGE_SIZE = "SET_USER_PAGE_SIZE"
export const SET_USER_TOTAL = "SET_USER_TOTAL"
export const SET_ALL_LEAVES = "SET_ALL_LEAVES"
export const SET_LEAVE_PAGE = "SET_LEAVE_PAGE"
export const SET_LEAVE_PAGE_SIZE = "SET_LEAVE_PAGE_SIZE"
export const SET_LEAVE_TOTAL = "SET_LEAVE_TOTAL"
export const SET_STATS = "SET_STATS"
export const RESET_STATS = "RESET_STATS"
export const SET_ESTIMATION_SUMMARY = "SET_ESTIMATION_SUMMARY"
export const SET_NOTIFICATION_FLAG = "SET_NOTIFICATION_FLAG"
export const SET_ANALYTICS_DATA = "SET_ANALYTICS_DATA"
export const SET_ANALYTICS_FILTER = "SET_ANALYTICS_FILTER"
export const RESET_ANALYTICS_FILTER = "RESET_ANALYTICS_FILTER"

